<template>
  <side-bar>
    <div class="prod-container">
      <div class="main-header ellipsis">
        <span
          @click="$router.push({ path: '/main/production' })"
          :style="{ cursor: 'pointer' }"
          >产品</span
        >
        <i class="el-icon-arrow-right"></i>
        <span>{{ info.name }}</span>
      </div>
      <div class="main-content">
        <div class="content-title">
          <span class="content-name">{{ info.name }}</span>
          <span>ID: {{ info.id }}</span>
          <div class="vertical-divider"></div>
          <span>设备注册数：</span>
          <span>{{ info.deviceNum }}</span>
        </div>
        <div class="prod-content">
          <div class="item-title">产品名称</div>
          <div class="item-text">{{ info.name }}</div>
          <div class="item-title">设备类型</div>
          <div class="item-text">{{ info.deviceType }}</div>
          <div class="item-title">协议类型</div>
          <div class="item-text">{{ info.protocolType | parseProtoText }}</div>
          <div class="item-title">数据格式</div>
          <div class="item-text">{{ info.dataEncode | parseDataEncode }}</div>
          <div class="item-title">创建时间</div>
          <div class="item-text">{{ info.createAt | parseTime }}</div>
          <div class="item-title">厂商名称</div>
          <div class="item-text">{{ info.companyName }}</div>
        </div>
        <div class="sub-title">模型定义</div>

        <div class="btns">
          <el-button
            type="primary"
            size="small"
            v-if="info.serves && !info.serves.length"
            @click="showAddServiceDialog"
            >自定义模型</el-button
          >
          <el-button
            type="primary"
            size="small"
            v-if="info.serves && info.serves.length"
            @click="showAddServiceDialog"
            >添加服务</el-button
          >
          <el-button size="small" v-if="showModel" @click="showSelector"
            >导入库模型</el-button
          >
          <el-button
            size="small"
            v-if="info.serves && info.serves.length"
            @click="saveModel"
            >保存为模型</el-button
          >
        </div>
        <div class="serves" v-if="info.serves">
          <service-item
            v-for="item in info.serves"
            :key="item.id + item.description + item.type"
            :item="item"
            :is-edit-mode="true"
            :is-call-mode="true"
            :clipboard="clipboard"
            @remove="removeServe(item)"
            @addCommand="addCommand"
            @addAttr="addAttr"
            @removeAttr="removeAttr"
            @removeCommand="removeCommand"
            @editAttr="editAttr"
            @editCommand="editCommand"
          ></service-item>
        </div>
      </div>
    </div>
    <add-service-dialog ref="addServiceDialog" />
    <modal-select-dialog ref="modalSelectDialog" />
    <custom-input-dialog ref="customInputDialog" />
  </side-bar>
</template>

<script>
import serviceItem from "../create/serviceItem";
import addServiceDialog from "../create/addServiceDialog";
import sideBar from "../../components/sideBar";
import { mapActions } from "vuex";
import Clipboard from "clipboard";
import modalSelectDialog from "../create/modalSelectDialog";
import customInputDialog from "../create/customInputDialog";
import { dealErrorCode } from "../../store/server";
export default {
  name: "productionInfo",
  components: {
    serviceItem,
    sideBar,
    addServiceDialog,
    modalSelectDialog,
    customInputDialog,
  },
  data() {
    return {
      info: {},
      showModel: false,
      clipboard: null,
    };
  },
  methods: {
    ...mapActions([
      "GetProductDetail",
      "GetModelList",
      "AddServe",
      "DeleteServe",
      "AddCommand",
      "SaveToModel",
      "AddProperty",
      "DeleteProperty",
      "DeleteCommand",
      "EditProperty",
      "EditCommand",
      "ImportFromModel",
    ]),
    async getData() {
      let data = await this.GetProductDetail(this.$route.query.id);
      if (data.code === 1000) {
        this.info = data.data;
      } else if (dealErrorCode(data.code)) {
        this.$message.error("获取数据失败");
      }
    },
    async getShowModel() {
      let res = await this.GetModelList({ page: 1, limit: 1 });
      if (res.code === 1000) {
        this.showModel = !!res.data.length;
      }
    },
    async showAddServiceDialog() {
      let res = await this.$refs.addServiceDialog.show({
        names:
          (this.info.serves && this.info.serves.map((item) => item.id)) || [],
      });
      if (res === null) {
        return;
      }

      await this.AddServe({ productId: this.info.id, ...res });
      await this.getData();
    },
    async removeServe(data) {
      this.$confirm(`是否删除名为${data.id}的服务？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(async () => {
          let index = this.info.serves.indexOf(data);
          if (index === -1) {
            return;
          }
          let res = await this.DeleteServe({
            serveId: data.id,
            productId: this.info.id,
          });
          if (res.code === 1000) {
            this.$message.success("删除服务成功");
            await this.getData();
          } else if (dealErrorCode(res.code)) {
            this.$message.error("删除服务失败");
          }
        })
        .catch((err) => {});
    },
    async addCommand(data) {
      let res = await this.AddCommand({ ...data, productId: this.info.id });
      if (res.code === 1000) {
        this.$message.success("添加命令成功");
        await this.getData();
      } else if (res.code === 21001) {
        this.$message.success("产品或服务不存在");
      } else if (dealErrorCode(res.code)) {
        this.$message.error("添加命令失败");
      }
    },
    async addAttr(data) {
      let res = await this.AddProperty({
        ...data,
        productId: this.info.id,
        enumData: data.enum,
      });
      if (res.code === 1000) {
        this.$message.success("添加属性成功");
        await this.getData();
      } else if (res.code === 21001) {
        this.$message.success("产品不存在");
      } else if (dealErrorCode(res.code)) {
        this.$message.error("添加属性失败");
      }
    },
    async editAttr(data) {
      let res = await this.EditProperty({
        ...data,
        productId: this.info.id,
        enumData: data.enum,
      });
      if (res.code === 1000) {
        this.$message.success("修改属性成功");
        await this.getData();
      } else if (res.code === 21001) {
        this.$message.success("产品不存在");
      } else if (dealErrorCode(res.code)) {
        this.$message.error("修改属性失败");
      }
    },
    async removeAttr(data) {
      let res = await this.DeleteProperty({ ...data, productId: this.info.id });
      if (res.code === 1000) {
        this.$message.success("删除属性成功");
        await this.getData();
      } else if (dealErrorCode(res.code)) {
        this.$message.error("删除属性失败");
      }
    },
    async removeCommand(data) {
      let res = await this.DeleteCommand({ ...data, productId: this.info.id });
      if (res.code === 1000) {
        this.$message.success("删除命令成功");
        await this.getData();
      } else if (res.code === 21001) {
        this.$message.success("命令不存在");
      } else if (dealErrorCode(res.code)) {
        this.$message.error("删除命令失败");
      }
    },
    async editCommand(data) {
      let res = await this.EditCommand({ ...data, productId: this.info.id });
      if (res.code === 1000) {
        this.$message.success("修改命令成功");
        await this.getData();
      } else if (res.code === 21001) {
        this.$message.success("命令不存在");
      } else if (dealErrorCode(res.code)) {
        this.$message.error("修改属性失败");
      }
    },
    async showSelector() {
      let res = await this.$refs.modalSelectDialog.show(this.selected);
      if (res === null) {
        return;
      }
      this.selected = res;
      let response = await this.ImportFromModel({
        productId: this.info.id,
        modelId: res.id,
      });
      if (response.code === 1000) {
        this.$message.success("导入成功");
        await this.getData();
      } else if (dealErrorCode(res.code)) {
        this.$message.error("导入失败");
      }
    },
    async saveModel() {
      let name = await this.$refs.customInputDialog.show({
        title: "输入模型名称",
      });
      if (name === null) {
        return;
      }

      let res = await this.SaveToModel({
        productId: this.$route.query.id,
        modelName: name,
      });
      if (res.code === 1000) {
        this.$message.success("保存成功");
      } else if (res.code === 1008) {
        this.$message.error("模型名称重复");
      } else if (res.code === 1009) {
        this.$message.error("对应产品不存在");
      } else if (dealErrorCode(res.code)) {
        this.$message.error("保存失败");
      }
    },
  },
  created() {
    this.getShowModel();
    this.getData();
  },
  mounted() {
    this.clipboard = new Clipboard(".copy-icon");
    this.clipboard.on("success", (e) => {
      this.$message.success("复制成功");
    });
  },
  beforeDestroy() {
    this.clipboard.destroy();
  },
};
</script>

<style scoped>
.btns {
  margin-bottom: 20px;
}
.prod-container {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 50px 0 0 20px;
  box-sizing: border-box;
}

.main-header {
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px dotted #ebebeb;
  position: absolute;
  left: 0;
  top: 0;
  color: rgba(0, 0, 0, 0.45);
  padding: 0 20px;
  box-sizing: border-box;
}
.main-header > span:last-child {
  color: rgba(0, 0, 0, 0.65);
}
.main-content {
  height: 100%;
  overflow: auto;
  padding-right: 20px;
  box-sizing: border-box;
}

.content-title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 13px;
  margin-bottom: 24px;
  word-break: break-all;
}
.content-title > span:first-child {
  font-weight: 600;
  font-size: 20px;
}

.content-title > span:last-child {
  color: #3389ff;
}
.content-title > * {
  margin-right: 7px;
}
.vertical-divider {
  width: 1px;
  height: 16px;
  background-color: #dddddd;
  display: inline-block;
}

.prod-content {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  margin-bottom: 50px;
}
.item-title {
  width: 10%;
  color: #999999;
  text-align: left;
  margin-bottom: 10px;
}
.item-text {
  width: 39%;
  color: #303133;
  text-align: left;
  margin-bottom: 10px;
  word-break: break-all;
  padding-right: 15px;
  box-sizing: border-box;
}

.sub-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}
.el-table{
    border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
}
</style>